export default __webpack_public_path__ + "static/media/GoodUpload.3e8d4a57.svg";